export class QuestionEntity {
  constructor() {
    this.index = 0;
    this.id = 0;
    this.qtype = "";
    this.haslatex = false;
    this.score = 0;
    this.knowledgeSerialnumber = "";
    this.level = 1;
    this.judge = false;
    this.steamjs = [];
    this.answerjs = [];
    this.solvejs = [];
    this.optionsjs = [];
    this.correctOrder = [];
    this.updatetime = "";
  }
  addChoice(text) {
    let lastid = this.steamjs.length - 1;
    let ranginfo = this.steamjs[lastid];
    console.log(this.steamjs);
    console.log(ranginfo);
    let userchoice = {
      wdType: 0,
      startpos: 1,
      imgstartpos: 0,
      imglen: 0,
      haslatex: true,
      latex: "",
      content: text
    };
    if (ranginfo.wordInfos.length > 0) {
      let lastwd = ranginfo.wordInfos.length - 1;
      userchoice.startpos = ranginfo.wordInfos[lastwd].startpos + 1;
    } else {
      userchoice.startpos = 1;
    }
    ranginfo.wordInfos.push(userchoice);
  }
  setUserChoice(userChoice) {
    const optioncodes = "ABCDEFGHIGKLMNOPQRSTUVWXYZ";
    if (this.qtype === "JudgX") {
      if (userChoice === "1") {
        this.addChoice("(正确)");
      }
      if (userChoice === "0") {
        this.addChoice("(错误)");
      }
    }
    if (this.qtype === "SingX" || this.qtype === "MultX") {
      let fixindexs = userChoice.split(",");
      let usrch = "";
      this.optionsjs.forEach((opt, index) => {
        fixindexs.forEach(fixidx => {
          if (opt.index.toString() === fixidx) {
            usrch = usrch + optioncodes[index] + ",";
          }
        });
      });
      console.log(usrch);
      if (usrch.length > 1) {
        usrch = usrch.slice(0, usrch.length - 1);
      }
      this.addChoice("(" + usrch + ")");
    }
  }
}
